import React from "react";
import { useLang } from "@/i18n";
import { MapPin, ExternalLink } from "lucide-react";
import { OrnateHeartDivider } from "./FloralOrnaments";
import GoogleMapsLogo from "./GoogleMapsLogo";

export default function MapCard({ wedding }) {
    const { t, lang } = useLang();
    const hall = lang === "ar" ? wedding.hall_ar : wedding.hall_en;
    return (
        <section data-testid="map-section" className="py-16 px-6">
            <div className="text-center">
                <p className="wd-label text-[var(--wd-accent)]">{t("joinUsAt")}</p>
                <a
                    href={wedding.maps_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wd-heading inline-flex items-center justify-center gap-2 text-3xl md:text-4xl text-[var(--wd-primary)] mt-2 hover:text-[var(--wd-accent)] transition-colors"
                    data-testid="map-venue-heading-link"
                >
                    {lang === "ar" ? wedding.venue_ar : wedding.venue_en}
                    <GoogleMapsLogo size={22} />
                </a>
                {hall ? (
                    <p className="wd-heading text-xl md:text-2xl text-[var(--wd-primary)] mt-2" data-testid="map-hall">
                        {hall}
                    </p>
                ) : null}
                <p className="mt-2 text-[var(--wd-text-muted)] text-sm">
                    {lang === "ar" ? wedding.city_ar : wedding.city_en}
                </p>
                <div className="mt-6 max-w-md mx-auto flex justify-center"><OrnateHeartDivider /></div>
            </div>

            <a
                href={wedding.maps_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="map-link"
                className="block mx-auto mt-10 max-w-xl group"
            >
                <div className="wd-card overflow-hidden relative transition-transform hover:-translate-y-1">
                    <iframe
                        title="Wedding venue map"
                        src={wedding.maps_embed}
                        className="w-full h-56 md:h-72 border-0 pointer-events-none"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[var(--wd-primary)]/20 to-transparent pointer-events-none" />
                    <div className="absolute bottom-3 left-0 right-0 flex items-center justify-center gap-2 text-white text-xs font-medium">
                        <MapPin size={14} className="drop-shadow" />
                        <span className="drop-shadow">{t("tapToOpenMap")}</span>
                    </div>
                </div>

                <div className="mt-6 text-center">
                    <span className="inline-flex items-center gap-2 wd-btn" data-testid="map-directions-btn">
                        {t("clickMap")}
                        <ExternalLink size={14} />
                    </span>
                </div>
            </a>
        </section>
    );
}
